const marionette = require('backbone.marionette'),
    LoadingView = require('shared/view/loadingView'),
    ErrorView = require('shared/view/errorView'),
    ajaxRequest = require('shared/util/ajaxRequest');
const DeepModel = require('base/backbone-deep-model');
const authMgr = require('app/authMgr');

const routerChannel = Backbone.Radio.channel('router');

module.exports = marionette.Object.extend({
    data: {},
    initialize: function () {
        if (_.isFunction(this.data)) {
            this._dataFn = this.data;
        }
    },
    show: function (target) {
        target.show(new LoadingView());
        let abortPromise = function (route) {
            if (Backbone.history.route !== route && promise && _.isFunction(promise.state) && promise.state() === 'pending') {
                (promise.abort || function () { })();
            }
        };
        this.listenTo(routerChannel, 'beforeRoute', abortPromise);
        let params = _.drop(arguments);
        let promise = authMgr.initializeAuthData()
            // Check Auth
            .then(function () {
                if (!this.unauthorized && !authMgr.isAuthenticated()) {
                    window.location.href = `./login.html?${Backbone.history.getFragment()}` 
                }
            }.bind(this))
            // Resolve controller data
            .then(function () {
                this.data = this._resolveData(params);
                return this.loadData.call(this, this.data, params)
            }.bind(this))
            // Show the view
            .then(function () {
                let view = this.render.apply(this, params);
                if (view) {
                    target.show(view);
                }
                this.stopListening(routerChannel, 'beforeRoute', abortPromise);
            }.bind(this))
            // Handle errors
            .catch(function (response) {
                console.error(response);
                let model = new Backbone.Model();
                this.stopListening(routerChannel, 'beforeRoute', abortPromise);
                if (response.status === 401) {
                    model.set('unauthorized', true);
                    authMgr.signOut(window.location.hash.replace('#', ''));
                }
                else {
                    target.show(new ErrorView({ model: model }));
                }
                throw response;
            }.bind(this));
    },
    // JB
    // I have the notion that we should break this out into a separate module,
    // so that it can be used in places other than a controller's data loading event.
    // One of the most obvious applications would be embedded layout views.
    // But this might only be useful in proportion to how often that situation exists. 
    loadData: function (data, params) {
        let requests = [];
        for (let key in data) {
            let fetchable = data[key];
            if (fetchable) {
                if (fetchable.fetch) {
                    requests.push(fetchable.fetch());
                }
                else if (_.has(fetchable, 'collection')) {
                    let collectionClass = Backbone.Collection.extend({
                        url: () => `./api${fetchable.collection}`,
                        model: DeepModel
                    });
                    data[key] = new collectionClass();
                    requests.push(data[key].fetch());
                }
                else if (_.has(fetchable, 'model')) {
                    let modelBase = fetchable.useDeepModel === false ? Backbone.Model : DeepModel;
                    let modelClass = modelBase.extend({ url: () => './api' + fetchable.model });
                    data[key] = new modelClass();
                    requests.push(data[key].fetch());
                }
                else if (_.has(fetchable, 'data')) {
                    let promise = ajaxRequest({
                        url: `./api${fetchable.data}`,
                        type: 'GET',
                    });
                    promise.then(function (responseData) {
                        data[key] = responseData;
                    });
                    requests.push(promise);
                }
            }
        }
        // Adds per-wellbore rights promise to the promise array, along with all the controller data model promises.
        requests = requests.concat(this._loadAuthorization(params));
        let promise = $.when.apply(this, requests);
        if (this.onDataError) {
            promise.catch(this.onDataError);
        }
        return promise;
    },
    _resolveData: function (args) {
        if (this._dataFn) {
            return this._dataFn.apply(this, args);
        }
        return this.data;
    },
    _loadAuthorization: function (args) {
        // Checks to see if the controller has set the loadWellboreAuthorization property.
        if (this.authorizationOptions) {
            if (this.authorizationOptions.loadWellboreAuthorization) {
                // If that property is set, this ensures we can get the wellboreId, even if it's not the only param passed to the controller.
                const getWellboreFromArgs = this.authorizationOptions.getWellboreFromArgs || ((args) => args[0]);
                // Returns the promise from the authMgr function to get rights from the server.
                return [authMgr.loadWellboreAuthorization(getWellboreFromArgs(args))];
            }
            else if (this.authorizationOptions.loadWellboreAuthorizationByEntry) {
                // If that property is set, this ensures we can get the entryId, even if it's not the only param passed to the controller.
                const getEntryFromArgs = this.authorizationOptions.getEntryFromArgs || ((args) => args[0]);
                // Returns the promise from the authMgr function to get rights from the server.
                return [authMgr.loadWellboreAuthorizationByEntry(getEntryFromArgs(args))];
            }
        }
        return []
    }
});
